// import { Link } from "react-router-dom";
import { Badges, P, SVG } from "../../../AbstractElements";
// import { Href } from "../../../utils/Constant";
// import { Rating } from "react-simple-star-rating";
// import { dynamicImage } from "../../../Service";
import { TableColumn } from "react-data-table-component";
import { AllCardAssignTableDataColumnType, AllCardAssignTableOffer } from "../../../Types/Application/Ecommerce/Ecommerce";
import Swal from "sweetalert2";
import api from "../../../utils/api";

export const allCardAssignTableData = [
    {
        cardAssignId: 17,
        ticketRFIdNo: "SWP-55-6",
        ticketRFIdRef: "REF-SWP-2311",
        status: true,
        cardAmount: 1000,
        cardAssignDate: "2025-05-13T16:53:29.1963072",
        rfId: 6,
        rfidCardUniqueNumber: 1234567890
    },
    {
        cardAssignId: 17,
        ticketRFIdNo: "SWP-55-7",
        ticketRFIdRef: "REF-SWP-2312",
        status: true,
        cardAmount: 1000,
        cardAssignDate: "2025-05-13T16:53:29.1963072",
        rfId: 6,
        rfidCardUniqueNumber: 1234567891
    },

];

// const ProductListTableAction = ({adultPlanId}) => {
//   return (
//     <div className="product-action">
//       <Link to={Href}>
//         <SVG iconId="edit-content" style={{ fill: 'blue' }} />
//       </Link>
//       <button className="btn btn-sm">
//       <SVG iconId="trash1" style={{ fill: 'red' }}/>
//       </button>
//       <p>{adultPlanId}</p>
//     </div>
//   );
// };

const handleDelete = async (id: number) => {
    try {
      await api.put(`/api/CardAssign/ReturnRFIDCard?rfid=${id}`);
      Swal.fire('Returned!', '  Card has been returned.', 'success');
  
      // Optional: refresh the list
    //   setCardAssignTableDatas((prev) => prev.filter((item: { adultPlanId: any; }) => item.adultPlanId !== id));
    } catch (error) {
      Swal.fire('Error!', 'Failed to return the card.', 'error');
      console.error("Returned error:", error);
    }
  };

interface ProductListTableActionProps {
    cardAssignId: any;
  onDelete: (id: number) => void;
}

export const AllCardAssignTableAction: React.FC<ProductListTableActionProps> = ({ cardAssignId, onDelete }) => {

  const handleDeleteClick = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this record!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, Return it!',
    }).then((result) => {
      if (result.isConfirmed) {
        onDelete(cardAssignId);
      }
    });
  };

  return (
    <div className="product-action d-flex gap-2">
      <button className="btn btn-sm" onClick={handleDeleteClick} title="Return Card">
        {/* <SVG iconId="trash1" style={{ fill: 'red' }} /> */}
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
  <path d="M19 7v4H6.83l3.59-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21V7z"/>
</svg>

      </button>
    </div>
  );
};

export const AllCardAssignTableProductName: React.FC<AllCardAssignTableOffer> = ({ title }) => {
  return (
    <div className="product-names my-2">
      <P>{title}</P>
    </div>
  );
};

export const AllCardAssignTableStatus :React.FC<AllCardAssignTableOffer> = ({ title }) => {
  return (
    <Badges color="" className={`badge-light-${title === "Active" ? "secondary" : "primary" }`}>{title}</Badges>
  );
};

export const allCardAssignTableDataColumn: TableColumn<AllCardAssignTableDataColumnType>[] = [
    {
      name: "Ticket Number",
      cell: (row) => <AllCardAssignTableProductName title={row.ticketRFIdNo}/>,
      sortable: true,
      grow: 2,
    },
    {
      name: "Ticket ID",
      selector: (row) => `${row.ticketRFIdRef}`,
      sortable: true,
      grow: 2,
    },
    {
      name: "RFID No.",
      selector: (row) => `${row.rfidCardUniqueNumber}`,
      sortable: true,
    },
    {
      name: "Amount",
      selector: (row) => `${row.cardAmount}`,
      sortable: true,
    },
    {
      name: "Assign Date",
      cell: (row) =>  <AllCardAssignTableStatus title={row.cardAssignDate} />,
    },
    {
        name: "Status",
        cell: (row) =>  <AllCardAssignTableStatus title={row.status} />,
    },
    {
      name: "Action",
      cell: (row) => <AllCardAssignTableAction cardAssignId={row.rfId} onDelete={handleDelete} />,
    },
  ];

  export const filtersData = [
    {
      name: "Choose Ticket No.",
      options: ["SWP-4893", "SWP-2311"],
    },
    {
      name: "Status",
      options: ["Active", "Inactive"],
    },
    {
      name: "customerMobileNumber",
      options: ["8347821920"],
    },
  ];